import {isNullOrUndefined} from "../../services/Validator";
import SystemScreenInfoTitleText from "../texts/SystemScreenInfoTitleText";
import SystemScreenInfoSubtitleText from "../texts/SystemScreenInfoSubtitleText";
import SystemScreenErrorIcon from "../icons/SystemScreenErrorIcon";
import {SystemPrimaryCustomButton} from "../buttons/SystemCustomButton";
import {kSystemTexts} from "../../constants/texts";
import {kButtonStyles} from "../../constants/styles";
import {CircularProgress} from "@mui/material";

export default function SystemAppContentError({error, isLoading, retryCallback, extraClass}) {
    // Used through the app to display an error object made of
    // error icon, title (problem) and subtitle (reinsurance)

    // BUILD
    return (
        <div className={"animate-appear w-[400px] flex flex-col justify-center items-center pt-[120px] " + extraClass}>
            <SystemScreenErrorIcon />
            <div className={"w-full flex flex-col justify-center items-center mt-[16px] space-y-[4px]"}>
                <SystemScreenInfoTitleText title={isNullOrUndefined(error) ? "Une erreur est survenue" : error.statement} />
                <SystemScreenInfoSubtitleText subtitle={isNullOrUndefined(error) ? "Nous faisons notre possible pour résoudre le problème au plus vite" : error.reassurance} />
            </div>
            <div className={"w-full flex space-x-[12px] mt-[24px]"}>
                <SystemPrimaryCustomButton
                    label={kSystemTexts.retry}
                    isDisabled={false}
                    isLoading={isLoading}
                    loaderComponent={<CircularProgress size={"24px"}
                                                       style={{'color' : 'white'}} />}
                    isFullWidth={true}
                    sizeStyle={kButtonStyles.mediumButtonStyle}
                    onButtonClick={() => retryCallback()} />
            </div>
        </div>
    );
}